import {all} from 'redux-saga/effects';
import {
    getUserSaga,
    clearUserSaga
} from 'feedback-system/auth/saga';
import {
    fetchConsolidatedFBSaga,
    postManagerRatingSaga,
    putManagerRatingSaga,
    deleteManagerRatingSaga,
    managerReadCommentSaga
} from 'feedback-system/modules/feedback-consolidation/services/saga';
import {
    searchAddUserSaga,
    searchAddUserClrSaga
} from 'feedback-system/modules/quality-feedback/add-user/add-user-dialog/services/saga';
import {
    authSagaGoogle,
    authSagaGoogleWithCode
} from '../modules/login/services/sagas';
import {
    fetchUsersSaga,
    addRoleSaga,
    deleteRoleSaga
} from '../modules/employees/services/sagas';
import {
    downloadToExcelSaga,
    downloadToGDriveSaga
} from 'feedback-system/modules/feedback-consolidation/export-menu/services/saga';
import {
    getPeriodsSaga,
    lockPeriodSaga,
    unlockPeriodSaga,
    openPeriodSaga
} from 'feedback-system/modules/main-container/services/saga';
import {
    getSyncStatusSaga,
    startSyncSaga
} from 'feedback-system/modules/admin/services/saga';
import {
    qualityFeedbackSagaAutosave,
    qualityFeedbackSagaDelete,
    qualityFeedbackSagaGet,
    qualityFeedbackSagaSubmit,
    qualityFeedbackSagaAdd,
    otherFeedbackSagaGet,
    otherFeedbackSagaRead
} from '../modules/quality-feedback/services/saga';
import {statisticFetchDataSaga} from 'feedback-system/modules/feedback-overview/services/sagas/statisticFetchDataSaga';
import {searchUserSaga} from 'feedback-system/modules/feedback-overview/search-user/services/searchUserSaga';

export default function* root() {
    yield all([
        getUserSaga(),
        clearUserSaga(),
        fetchConsolidatedFBSaga(),
        postManagerRatingSaga(),
        putManagerRatingSaga(),
        deleteManagerRatingSaga(),
        managerReadCommentSaga(),
        searchAddUserSaga(),
        statisticFetchDataSaga(),
        searchAddUserClrSaga(),
        fetchUsersSaga(),
        addRoleSaga(),
        deleteRoleSaga(),
        authSagaGoogle(),
        authSagaGoogleWithCode(),
        getPeriodsSaga(),
        openPeriodSaga(),
        lockPeriodSaga(),
        unlockPeriodSaga(),
        qualityFeedbackSagaDelete(),
        qualityFeedbackSagaGet(),
        qualityFeedbackSagaAutosave(),
        qualityFeedbackSagaSubmit(),
        qualityFeedbackSagaAdd(),
        otherFeedbackSagaGet(),
        otherFeedbackSagaRead(),
        downloadToExcelSaga(),
        downloadToGDriveSaga(),
        getSyncStatusSaga(),
        startSyncSaga(),
        searchUserSaga()
    ]);
}
